module.exports = __webpack_public_path__ + "static/media/1010096.881aaea3.jpg";